import { NavLink, Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/features/auth/hooks/useAuth';
import ReportFilters from '@/features/reports/components/ReportFilters';
import { useReportFilters } from '@/features/reports/hooks/useReports';
import { sectionsForRole } from '@/features/reports/lib/sections';

/**
 * Shell for every report page.
 *
 * It owns the filter state (kept in the URL) and the section tabs, then hands
 * both down through the router outlet context so pages never re-declare them.
 */
export default function ReportsLayout() {
    const { activeRole } = useAuth();
    const { pathname } = useLocation();
    const reportFilters = useReportFilters();

    const sections = sectionsForRole(activeRole);
    const activeKey = sections.find((section) => pathname.includes(`/reports/${section.path}`))?.key;

    return (
        <div className="reports-shell">
            <header className="admin-page-header reports-header">
                <div>
                    <h1 className="admin-page-title">گزارش‌ها</h1>
                    <p className="admin-page-subtitle">
                        تحلیل فروش، کالا، انبار و مشتریان در بازه زمانی دلخواه
                    </p>
                </div>
            </header>

            <nav className="report-tabs" aria-label="بخش‌های گزارش">
                {sections.map((section) => {
                    const Icon = section.icon;
                    return (
                        <NavLink
                            key={section.key}
                            to={section.path}
                            className={({ isActive }) => `report-tab${isActive ? ' report-tab-active' : ''}`}
                            title={section.description}
                        >
                            <Icon size={16} aria-hidden="true" />
                            <span>{section.label}</span>
                        </NavLink>
                    );
                })}
            </nav>

            <ReportFilters
                {...reportFilters}
                granularityRelevant={activeKey === 'sales'}
            />

            <div className="reports-body">
                <Outlet context={{ ...reportFilters, activeRole }} />
            </div>
        </div>
    );
}

/** Redirect for the bare `/reports` URL: land on the first allowed section. */
export function ReportsIndexRedirect() {
    const { activeRole } = useAuth();
    const first = sectionsForRole(activeRole)[0];
    return <Navigate to={first ? first.path : 'sales'} replace />;
}
